// extracted by mini-css-extract-plugin
export default {"product_container":"Results_product_container__l+n+e"};